export const UPDATE_VENUE= 'UPDATE_VENUE'
export const UPDATE_VENUE_SUCCESS= 'UPDATE_VENUE_SUCCESS'
export const UPDATE_VENUE_ERROR='UPDATE_VENUE_ERROR'

export const UpdateVenue= (data) => ({
    type: UPDATE_VENUE,
    payload: data
})